import { breakpointsMasterCss, useBreakpoints } from "@vueuse/core";

export function useSpriteThumbnails() {
  const color = useColorMode();
  const breakpoints = useBreakpoints(breakpointsMasterCss);

  const spriteOptions = computed(() => {
    let size = "large";
    let width = 120;
    let cells = 1;
    const height = 64;

    if (breakpoints.between("md", "xl").value) {
      size = "medium";
      width = 100;
    }
    else if (breakpoints.between("xl", "2xl").value) {
      width = 120;
    }
    else if (breakpoints.between("2xl", "3xl").value) {
      width = 130;
      cells = 1;
    }
    else if (breakpoints.greater("4xl").value) {
      width = 80;
      cells = 2;
    }

    const url = `/sprite_${color.value}_${size}.png`;

    return { url, width, height, rows: 1, cells };
  });

  return spriteOptions;
}
